import React from 'react';

declare var $: any;
declare var window: any;

export class BaseComponent<P, S> extends React.Component<P, S> {
  public subscribed = [];
  public loadPageData_OnlyOnceGuard = false;

  public _doLoadingPageDataInDidMount = true;
  public _doInitInDidMount = true;

  constructor(props?: any) {
    super(props);
  }


  async componentDidMount() {
    //<editor-fold desc="Init (Once only)" defaultstate="collapsed" >
    if (this._doInitInDidMount === true) {
      this._doInitInDidMount = false;  // make it once only

      // window.$ = jQuery;
      // jQuery('[data-my-script]').each(function forEachScript() {
      //     const script = jQuery(this).text();
      //     // @ts-ignore
      //     window.eval(script);
      // });
      //
      //this.setState({showModal:true});
    }
    //</editor-fold>

    //#region Postpone Loading
    if (this._doLoadingPageDataInDidMount) {
      // @ts-ignore
      if (typeof this.afterEventsLoader === 'function') {
        // @ts-ignore
        await this.afterEventsLoader();
      }
    } else {
      return;
    }
    //#endregion

  }

  async componentWillUnmount() {
    //await super.componentWillUnmount();

    if ('subscribed' in this) {
      this.subscribed.forEach((v, i) => {
        v.unsubscribe();
      });
      this.subscribed = [];
    }
  }


  async componentDidUpdate(prevProps: any, prevState: any, snapshot?: any) {
    const locationChanged = this.props.location !== prevProps.location;
    if (locationChanged === true) {
      this._doLoadingPageDataInDidMount = true;
    }

    //#region Postpone Loading
    if (this._doLoadingPageDataInDidMount) {
      // @ts-ignore
      if (typeof this.afterEventsLoader === 'function') {
        // @ts-ignore
        await this.afterEventsLoader();
      }
    } else {
      return;
    }
    //#endregion

    //console.error(this.props.location);

    // if (locationChanged || this.state.shouldLoadPageDataAgain) {
    //   if (this.state.shouldLoadPageDataAgain !== false) {
    //     await this.setState({shouldLoadPageDataAgain: false});
    //   }
    //   await this._loadPageData();
    // }
    //
    // && this.props.location.pathname == this.state.pagePathname
    // if (locationChanged) {
    //   //await this._loadPageData();
    //   await this.componentDidMount();
    // }
  }
}
